import { useQuery } from "react-query";
import axios from "infra/http";
import { TenantUsuarioFormulario } from "../typings/tenant";

interface UseGetTenantUsuariosProps {
  tenantId?: string;
  usuarioId?: string;
}

function useGetTenantUsuarios({
  tenantId,
  usuarioId,
}: UseGetTenantUsuariosProps) {
  return useQuery(
    [`/v1/tenants/${tenantId}/usuarios/${usuarioId}`],
    async () => {
      const res = await axios.get<TenantUsuarioFormulario>(
        `/v1/tenants/${tenantId}/usuarios/${usuarioId}`
      );

      return res.data;
    },
    {
      enabled: !!tenantId && !!usuarioId,
    }
  );
}

export default useGetTenantUsuarios;
